import request from '@/utils/request'

// 查询推荐配置
export function getRecommendConfig(query) {
  return request({
    url: '/biz/admin/community/recommend/config/detail',
    method: 'get',
    params: query
  })
}

// 保存推荐配置
export function saveRecommendConfig(data) {
  return request({
    url: '/biz/admin/community/recommend/config/save',
    method: 'post',
    data: data
  })
}
